(() => {
  const init = (root = document) => root.querySelectorAll('[data-nf-category]').forEach(page => {
    if (page.dataset.ready) return;
    page.dataset.ready = 'true';
    const abort = new AbortController(), signal = abort.signal;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const cards = [...page.querySelectorAll('.nfcat__card')];
    const filters = page.querySelector('.nfcat__filters');
    const buttons = [...page.querySelectorAll('[data-nfcat-filter]')];
    const count = page.querySelector('[data-nfcat-count]');
    const empty = page.querySelector('.nfcat__empty');
    buttons.forEach(button => {
      const group = button.dataset.nfcatFilter;
      if (group !== 'all' && !cards.some(card => card.dataset.nfcatGroups.split(/\s+/).includes(group))) button.hidden = true;
      button.addEventListener('click', () => {
        let visible = 0;
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        cards.forEach(card => {
          const show = group === 'all' || card.dataset.nfcatGroups.split(/\s+/).includes(group);
          card.hidden = !show;
          if (show) { visible++; card.classList.remove('is-waiting'); }
        });
        count.textContent = String(visible);
        empty.hidden = visible !== 0;
      }, {signal});
    });
    filters.hidden = buttons.filter(button => !button.hidden).length < 3;
    const select = page.querySelector('[name=sort_by]');
    select.addEventListener('change', () => select.form.requestSubmit(), {signal});
    let observer;
    if ('IntersectionObserver' in window && !reduced.matches) {
      observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.remove('is-waiting'); observer.unobserve(entry.target); }
      }), {threshold:.04});
      cards.forEach(card => { if (card.getBoundingClientRect().top > innerHeight) card.classList.add('is-waiting'); observer.observe(card); });
    }
    const hero = page.querySelector('.nfcat__hero');
    const pointer = matchMedia('(hover:hover) and (pointer:fine)');
    let frame = 0;
    const reset = () => { cancelAnimationFrame(frame); hero.style.removeProperty('--hero-x'); hero.style.removeProperty('--hero-y'); };
    hero.addEventListener('pointermove', event => {
      if (reduced.matches || !pointer.matches) return;
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const box = hero.getBoundingClientRect();
        hero.style.setProperty('--hero-x', ((event.clientX-box.left)/box.width-.5)*-15+'px');
        hero.style.setProperty('--hero-y', ((event.clientY-box.top)/box.height-.5)*-10+'px');
      });
    }, {passive:true,signal});
    hero.addEventListener('pointerleave', reset, {signal});
    reduced.addEventListener('change', () => {
      if (reduced.matches) { reset(); observer?.disconnect(); cards.forEach(card => card.classList.remove('is-waiting')); }
    }, {signal});
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(page)) { abort.abort(); observer?.disconnect(); reset(); }
    }, {signal});
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true}); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
